"use client";

import { Separator } from "@/components/ui/separator";
import { TermsOfUseContent } from "@/components/terms/terms-of-use-content";
import { TermsTabs } from "@/components/terms/terms-tabs";
import { useEffect } from "react";
import { setPageTitle } from "@/lib/page-titles";

export default function TermsOfUsePage() {
  // Set page title
  useEffect(() => {
    setPageTitle("Terms of Use");
  }, []);

  return (
    <div className="bg-ui-bg-subtle min-h-screen">
      <div className="container mx-auto max-w-4xl px-6 py-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex flex-col items-center text-center">
            <img
              src="/logos/Symbolica-Logo_FullLockup_White.svg"
              alt="Symbolica Logo"
              width={200}
              height={50}
              className="mb-6"
            />
            <h1 className="font-arizona-sans mb-2 text-[32px] font-normal leading-[100%] tracking-[-0.64px] text-[#FFFDF9]">
              Terms of Use
            </h1>
            <p className="text-muted-foreground text-sm">
              Last revised: 2 March 2026
            </p>
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-8">
          <TermsTabs />
        </div>

        {/* Terms Content */}
        <TermsOfUseContent />

        <Separator className="my-8" />

        {/* Footer */}
        <div className="text-center">
          <p className="text-muted-foreground text-sm">
            For questions about these legal documents, please contact us at{" "}
            <a
              href="mailto:hello@symbolica.ai"
              className="hover:text-foreground underline"
            >
              hello@symbolica.ai
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
